import React from 'react';
import PersonnelList from '../components/PersonnelList';

const PersonnelPage = () => {
  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ margin: 0 }}>Gestion du Personnel</h2>
        <p style={{ color: '#666', marginTop: '8px' }}>
          Gérez vos employés et leurs informations
        </p>
      </div>
      <PersonnelList />
    </div>
  );
};

export default PersonnelPage;